import { type Dispatch, type SetStateAction, useEffect, useState } from 'react'

interface IUseGlbZipCodeModalInfoProps {
  zip: string
  open: boolean
}

interface IUseGlbZipCodeModalInfo {
  currentZipValue: string
  errorMessage: string
  setErrorMessage: Dispatch<SetStateAction<string>>
  setCurrentZipValue: Dispatch<SetStateAction<string>>
}

export const useGlbZipCodeModalInfo: (
  props: IUseGlbZipCodeModalInfoProps
) => IUseGlbZipCodeModalInfo = ({ zip, open }) => {
  const [currentZipValue, setCurrentZipValue] = useState(zip)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    setCurrentZipValue(zip)
  }, [zip])

  useEffect(() => {
    if (!open) {
      setErrorMessage('')
    }
  }, [open])

  return {
    currentZipValue,
    errorMessage,
    setErrorMessage,
    setCurrentZipValue,
  }
}
